import { VisitStatus } from "../types";
import { includes } from "lodash";

export function isPastVisit(status: VisitStatus | undefined): boolean {
  return includes([VisitStatus.Denied, VisitStatus.Completed], status);
}
